import axios from 'axios';
import { api } from '@/api';
import { Mall } from 'supporter';
import JwtDecode from 'jwt-decode';
import { addProductDetailUrlPreview } from './formatUtils';
import { StartAndEndYmdHm } from '@/types';
import Cookies from 'js-cookie';
import { SHOPBY_REFRESHTOKEN } from '@/const/words/cookie';

export function ncpPopup(sURL: string, sWindowName: string, w: number, h: number, sScroll: string = 'no'): Window {
  const x = (screen.width - w) / 2;
  const y = (screen.height - h) / 2;

  if (screen.width == 800 && screen.height == 600) {
    sScroll = 'yes';
  }

  let sOption = '';
  sOption = `${sOption}toolbar=no, channelmode=no, location=no, directories=no, menubar=no`;
  sOption = `${sOption}, top=${y}, left=${x}, scrollbars=${sScroll}, width=${w}, height=${h}, resizable=no`;
  const win = window.open(sURL, sWindowName, sOption);

  if (win == null) {
    throw new Error('new Popup Error : window.open return null');
  }

  try {
    win.moveTo(x, y);
    win.focus();
  } catch (e) {}

  return win;
}
export function getFirstAndEndDay(yr: any, mm: any, separator?: any): StartAndEndYmdHm {
  if (mm < 10) {
    mm = '0' + mm;
  }

  if (separator === null || separator === undefined) {
    separator = '-';
  }

  const startYmd = yr + separator + mm + separator + '01 00:00:00';

  const myDate = new Date(yr, mm, 0);
  const endYmd = yr + separator + mm + separator + myDate.getDate() + ' 00:00:00';

  return { startYmd, endYmd };
}

export function decode(token: string): any {
  return JwtDecode(token);
}

/**
 * Type 'string | undefined' is not assignable to type 'string'.
 * so judge the type transform string.
 * @author AZu
 * @param needToI18nStr string of need to i18n
 */
export function toI18n(needToI18nStr: any): string {
  if (typeof needToI18nStr === 'string') {
    return needToI18nStr;
  } else {
    return '';
  }
}

/**
 * Get center popup options.
 * @author AZu
 * @param w the window.open width
 * @param h the window.open heigth
 * @param sScroll is show scroll bar :"yes" or no
 */
export function centerWinOptions(w: number, h: number, sScroll: string = 'no'): string {
  const x = (window.screenX || window.screenLeft || 0) + (screen.width - w) / 2;
  const y = (window.screenY || window.screenTop || 0) + (screen.height - h) / 2;

  let sOption = '';
  sOption += 'toolbar=no, channelmode=no, location=no, directories=no, resizable=yes, menubar=no';
  sOption += ', scrollbars=' + sScroll + ', left=' + x + ', top=' + y + ', width=' + w + ', height=' + h;
  return sOption;
}

/**
 * Center a popup window on screen.
 * @author AZu
 * @param sURL  need to open url
 * @param sWindowName the name of window.open
 * @param w the window.open width
 * @param h the window.open heigth
 * @param sScroll is show scroll bar :"yes" or no
 */
export function openWin(sURL: string, sWindowName: string, w: number, h: number, sScroll: string = 'no'): any {
  const win = window.open(sURL, sWindowName, centerWinOptions(w, h, sScroll));
  if (win) win.focus();
  return win;
}

const unescapedHtmlRegex = /[&<>"']/g;

const htmlMap = new Map<string, string>([
  ['&', '&amp;'],
  ['<', '&lt;'],
  ['>', '&gt;'],
  ['"', '&quot;'],
  // eslint-disable-next-line quotes
  ["'", '&#39;'],
]);

export function escapeHtml(html: string): string {
  return html.replace(unescapedHtmlRegex, (substring: string): string => htmlMap.get(substring) || '');
}

/**
 * tui.grid radio button
 * ref eg: src\views\admin\AdminList.vue
 * @author AZu
 */
export class RadioRenderer {
  private el: HTMLInputElement;
  private constructor(props: any) {
    const { grid, rowKey } = props;
    const radioBtn = document.createElement('input');
    radioBtn.type = 'radio';
    radioBtn.name = 'listRadio';
    radioBtn.addEventListener('change', (): void => {
      grid.uncheckAll();
      grid.check(rowKey);
    });

    this.el = radioBtn;
    this.render(props);
  }

  public getElement(): HTMLInputElement {
    return this.el;
  }

  public render(props: any): void {
    let checkedRowKeys = props.grid.getCheckedRowKeys();
    this.el.checked = checkedRowKeys.some((checkedRowKey): boolean => checkedRowKey === props.rowKey);
  }
}

/**
 * ref eg: src\views\product\ProductList.vue
 * @author AZu
 */
export function getCurrency(value: any, usePoint = false): string {
  if (value === '') {
    return '';
  }
  if (value === '-') {
    return '-';
  }
  if (value === '-0') {
    return '-0';
  }
  if (value == null || isNaN(value)) {
    if (usePoint) return '0.00';
    return '0';
  }

  let retVal = '';
  if (usePoint) {
    let parts = parseFloat(value)
      .toFixed(2)
      .toString()
      .split('.');
    if (parts.length == 2) {
      retVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}.${parts[1]}`;
    } else {
      retVal = '0';
    }
  } else {
    retVal = parseInt(value)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return retVal;
}
/**
 * image upload
 * @author AZu
 * @param files Input's files when input on changed.
 * @param mallNo
 */
export function uploadFile(files: any, mallNo: string): any {
  return new Promise((resolve: any, reject: any): void => {
    axios
      .all(
        Object.values(files).map((file: any): any => {
          const data = new FormData();
          data.append('file', file);
          return api.postImages({ data, params: { mallNo: Number(mallNo) } });
        }),
      )
      .then(
        axios.spread((...responses): void => {
          resolve(responses);
        }),
      )
      .catch((err: any): void => {
        reject(err);
      });
  });
}
/**
 * Check if a string is HTML
 * @author AZu
 * @param str
 */
export function isHTML(str: string): boolean {
  const a = document.createElement('div');
  a.innerHTML = str;

  for (let c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType == 1) return true;
  }

  return false;
}
/**
 * getMallsConfigurationsByKey
 * @author AZu
 */
export function getMallsConfigurationsByKey($this: any, key: string): any {
  const malls: Mall[] = getLocalStorageMalls();
  return new Promise((resolve: any, reject: any): void => {
    axios
      .all(
        malls.map((mall: Mall): any => {
          const mallNo = mall.mallNo.toString();
          return $this.$api.getMallsConfigurations({
            pathParams: { mallNo },
            params: { key },
          });
        }),
      )
      .then(
        axios.spread((...responses): void => {
          const res = responses.map(({ data: { productDetailUrl }, config: { url } }: any): any => {
            return { productDetailUrl, mallNo: url.replace(/[^\d]+(\d+)\/configurations/, '$1') };
          });
          resolve(res);
        }),
      )
      .catch((err: any): void => {
        reject(err);
      });
  });
}

export const convertProductUri = (uri: string, replacementData: string): string => {
  if (!uri?.length) {
    return '';
  }

  if (uri.includes('${mallProductNo}')) {
    const convertUri = uri.replace('${mallProductNo}', replacementData);

    return convertUri.includes('?') ? convertUri + '&preview=true' : convertUri + '?preview=true';
  }

  if (uri.includes('{productNo}')) {
    const convertUri = uri.replace('{productNo}', replacementData);

    return convertUri.includes('?') ? convertUri + '&preview=true' : convertUri + '?preview=true';
  }

  return '';
};
/**
 * productNameConvertor
 * @author AZu
 */
export function productNameConvertor(columnValue: any, row: any): string {
  let columnTxt = '';
  $.parseHTML(columnValue).forEach((v: any): void => {
    if (v.nodeName === '#text') {
      columnTxt += v.textContent;
    } else {
      columnTxt += v.outerHTML;
    }
  });

  const productName = escapeHtml(columnTxt);
  let extraTag = '';
  if (row['optionType'] === 'MAPPING') {
    extraTag = extraTag.concat('<span class="tag pink">' + window.$t('PRODUCT_PRODUCTLIST_SET') + '</span>'); //세트
  }

  if (row['classType'] === 'RENTAL') {
    extraTag = extraTag.concat('<span class="tag">' + window.$t('PRODUCT_PRODUCTLIST_RENTAL') + '</span>');
  }

  const TAG = {
    pcYn: '<span class="tag">PC</span>',
    mobileYn: '<span class="tag">M</span>',
    mobileWebYn: '<span class="tag">MW</span>',
  };
  const targetPlatforms = ['pcYn', 'mobileYn', 'mobileWebYn']
    .filter((v: any): any => {
      return row.platformDisplayInfo[v] === 'Y';
    })
    .map((v: any): any => {
      return v;
    });
  if (targetPlatforms.length > 2) {
    return extraTag ? `<div class="uio_bx">${extraTag}</div> ${productName}` : productName;
  }

  const tag = targetPlatforms.map((v: 'pcYn' | 'mobileYn' | 'mobileWebYn'): any => {
    return TAG[v];
  });
  const value = `<div class="uio_bx">${extraTag}${tag.join('')}</div> ${productName}`;

  return value;
}
/**
 * getStockCntColumnValue
 * @author AZu
 */
export function getStockCntColumnValue(
  representStockCnt: number,
  stockCnt: number,
  optionType: string,
  isSoldOut: boolean,
): string {
  const representCnt = representStockCnt;
  const isCombinationOption = optionType === 'COMBINATION';

  if (isSoldOut) {
    if (stockCnt === 0) {
      return window.$t('PRODUCT_PRODUCTLIST_SOLD_OUT'); //품절
    }
    return isCombinationOption ? `${window.$t('PRODUCT_PRODUCTLIST_SOLD_OUT')} (${stockCnt})` : `${stockCnt}`; //품절
  }

  return isCombinationOption ? `${representCnt} (${stockCnt})` : `${stockCnt}`;
}

/**
 * getMallsConfigurationsWmsUsedList
 * @author xzq
 */
export function getMallsConfigurationsWmsUsedList($this: any, key: string): any {
  const malls: Mall[] = getLocalStorageMalls();
  return new Promise((resolve: any, reject: any): void => {
    axios
      .all(
        malls.map((mall: Mall): any => {
          const mallNo = mall.mallNo.toString();
          return $this.$api.getMallsConfigurations({
            pathParams: { mallNo },
            params: { key },
          });
        }),
      )
      .then(
        axios.spread((...responses): void => {
          const res = responses.map(({ data: { wmsUsed }, config: { url } }: any): any => {
            return { wmsUsed, mallNo: url.replace(/[^\d]+(\d+)\/configurations/, '$1') };
          });
          resolve(res);
        }),
      )
      .catch((err: any): void => {
        reject(err);
      });
  });
}

export function range(start: number, end: number): number[] {
  const size = end - start + 1;

  return [...Array(size).keys()];
}

export function getProductsConfigurationsByAllMall(): any {
  const malls: Mall[] = JSON.parse(window.localStorage.mallInfo).filter(mall=> mall.used && (mall.mallStatus === 'ACTIVE' || mall.mallStatus === 'BLOCKED'));
  return new Promise((resolve: any, reject: any): void => {
    axios
      .all(
        malls.map((mall): any => {
          return api.getProductsConfiguration({ params: { mallNo: mall.mallNo } });
        }),
      )
      .then(
        axios.spread((...responses): void => {
          const res = responses.map((item): any => {
            return {
              mallNo: item.config.params.mallNo,
              productDetailUrl: addProductDetailUrlPreview(item.data.productDetailUrl),
            };
          });
          resolve(res);
        }),
      )
      .catch((err: any): void => {
        reject(err);
      });
  });
}

export function swapArrayOrder(array: any, from: number, to: number): any {
  return array.splice(from, 1, array.splice(to, 1, array[from])[0]);
}

export const masking = (str: string, start = 0) => {
  if (!str) {
    return str;
  }

  let newStr = '';
  for (let i = 0; i < str.length; i++) {
    if (i < start) {
      newStr += str[i];
    } else {
      newStr += '*';
    }
  }
  return newStr;
};

export const generateUriWithQuery = (baseUrl: string, query) => `${baseUrl}?${new URLSearchParams({ ...query })}`;

export function openProAdminContentsPopup(path: string) {
  const refreshToken = Cookies.get(SHOPBY_REFRESHTOKEN);
  const uri = `${process.env.VUE_APP_PRO_ADMIN_URL}${path}?refresh=${refreshToken}`;
  //localhost에서 테스트할 때
  // const uri = `https://alpha-admin.shopby.co.kr${path}?refresh=${refreshToken}`;

  ncpPopup(uri, 'openProAdminContentsPopup', 1700, 800);
}

//NOTE : window.localStorage.mallInfo  => store malls 으로 변경건으로 사이드 이펙트 발생시 빠르기 수정하기 위한 코드 (리소스를 아끼자)
export const getLocalStorageMalls = () =>  JSON.parse(window.localStorage.mallInfo).filter(({used, mallStatus}): boolean => used && (mallStatus === 'ACTIVE' || mallStatus === 'BLOCKED'));